import index from './zh/index'
import chat from './zh/chat'
import employee from './zh/employee'
import news from './zh/news'
import collection from './zh/collection'
import opportunity from './zh/opportunity'
import potentialOrder from './zh/potentialOrder'
import clientPool from './zh/clientPool'
import hotspot from './zh/hotspot'

export default {
  ...chat,
  ...employee,
  ...collection,
  ...opportunity,
  ...news,
  ...potentialOrder,
  ...hotspot,
  ...clientPool,
  rLogin: {
    'systemTip': '系统提示',
    'loginExpired': '登录状态已过期，请重新登录',
    'cancel': '取消',
    'loginAgain': '重新登录'
  },
  language: {
    name: 'zh'
  },
  ...index,
  tip: {
    success: '成功',
    loading: '加载中...'
  },
  live: {
    status: {
      '0': '直播中',
      '1': '待直播',
      '2': '回放'
    },
    startTime: '开播时间',
    looker: '在看',
    toLive: '进入直播'
  },
  Hello: '您好',
  like: '赞',
  exhibitorInfo: '展商详情',
  follow: '关注',
  joinExhibitorNum: '参展次数',
  registeredCapital: '注册资本',
  scaleOfCompany: '公司规模',
  collect: ['收藏', '已收藏'],
  message: '消息',
  'Send message': '发送消息',
  invite: '邀约',
  details: '详情',
  placeholder: '请输入您的',
  pageView: '人浏览',
  collection: '人收藏',
  editor: '编辑',
  companyEditor: '公司信息编辑',
  del: '删除',
  selectType: '请选择类别',
  auditStatus: ['审核通过', '待审核', '未通过审核'],
  upgradeBrowser: '请升级您的浏览器...',
  'Page not found': '页面未找到',

  // Header translation
  logout: '退出登录',
  profile: '个人中心',
  notification: '消息中心',
  myFavorite: '我的收藏',
  watchHistory: '浏览记录',
  customService: '客服中心',
  serviceTel: '客服电话',
  invitation: '邀约管理',
  marketing: '商机管理',
  invitationManagement: "邀约管理",
  operationGuide: '操作指南',
  moreFeature: '更多功能',
  baseMess: '基本信息',
  companyManage: '公司管理',
  companybaseMessManage: '基本信息管理',
  exhibitsManage: '展品管理',
  actor: '观众',
  exhibitors: '展商',
  exhibits: '展品',
  business: '商机',
  find: '找',
  home: '首页',
  baoiHome: '锦汉家居礼品展线上展2020',
  qatitle: 'Q&A',
  img: '图片',
  video: '视频',
  address: '地址',
  tel: '电话',
  email: '邮箱',
  www: '网站',
  registerLogin: '欢迎登录',
  passLogin: '使用邮箱登录',
  codeLogin: '使用手机号登录',
  getCode: '获取验证码',
  login: '登录',
  register: '新用户注册',
  code: '验证码',
  password: '密码',
  phone: '手机号',
  resetPassword: '设置密码',
  confirm: '确认',
  confirmPassword: '确认密码',
  forgetPassword: '忘记密码?',
  exhibitorCode: '展商确认码',
  backLogin: '返回登录',
  bindExhibitor: '绑定展商',
  setPassPageTip: [
    '我们已给您发送了验证码认邮件，请登录您的邮箱查收验证码，以完成您的密码设置。',
    '设置登录密码以后可使用该密码进行登录'
  ],
  myIndentity: ['我是展商', 'I am exhibitor', '我是观众', 'I am visitor'],
  save: '保存',
  'company name': '公司名称',
  name: '姓名',
  post: '职务',
  country: '国家',
  province: '省份',
  city: '城市',
  ydjTip: '注册功能暂未开放，敬请期待！',
  'You sign up and agree': '登录即同意',
  'Privacy agreement': '《隐私协议》',
  // exhibits form
  'Add Exhibit': '添加展品',
  'Edit Exhibit': '编辑展品',
  'My Exhibit List': '展品列表',
  'Upload picture': '上传照片',
  'Upload picture3': '上传照片',
  'Upload picture4': '上传照片',
  'Upload picture2': '上传宣传图片',
  'Upload again': '重新上传',
  'Add picture': '添加图片',
  'Only support png & jpg, less than 1Mb': '最佳效果尺寸1200*560像素，png或jpg格式，不超过2M',
  'Only support png & jpg, less than 1Mb 350px': '图片为正方形， 最佳效果尺寸350*350像素，png或jpg格式，不超过2M',
  'uploadTips2': '支持png、jpg格式，不超过2M的竖向长图, 如果图片太长建议切图',
  'Uploaded image only support png and jpg': '上传图片只能是 PNG, JPG 格式!',
  'Uploaded image can not greater than 1Mb': '上传图片不能大于2M',
  'Uploaded image can not greater than 10Mb': '上传图片不能大于10M',
  'Upload video': '上传视频',
  'Add video': '添加视频',
  'Only support mp4, less than 100Mb': '上传视频不超过100M',
  'Only support mp4, less than 10Mb': '上传视频不超过100M',
  'Uploaded video only support mp4': '上传视频只能是MP4格式',
  'Uploaded video can not greater than 100Mb': '上传视频不能大于100M',
  'Uploaded video can not greater than 10Mb': '上传视频不能大于10M',
  'Upload long picture': '上传长图',
  'Add product tags': '添加产品标签',
  'Add form data': '添加数据项',
  'Confirm and publish': '确认发布',
  Yes: '是',
  No: '否',
  'Please fill product name': '请输入产品名称',
  'Please upload at least one picture': '请上传至少一张图片',
  'Please select product tag': '请选择产品标签',
  'Please upload at least one long picture': '请上传至少一张长图',
  'Please select identity': '请选择身份',
  // exhibit detail
  'Exhibitor Name': '所属展商',
  'Exhibit Brand': '展品品牌',
  'Minimum Order Quantity': '可提供最小订货量',
  'Product BuyPrice': '采购价',
  'Product SalePrice': '销售价',
  'Spot Trading': '是否有现货',
  'Product tags': '展品标签',
  'Product Identification': '展品标识',
  'Customization Services': '定制服务',
  'Visible scope': '可见范围',
  'Copy Link': '复制链接',
  Copied: '复制成功',
  'productSearch': '展品名称或货号搜索',
  // company info
  'Upload logo': '上传LOGO',
  'Add company tags': '添加展商标签',
  'Add company description': '添加公司描述',
  'Improve Exhibitor Information': '完善展商信息',
  'comingSoon': '您已注册，请在10月21-27日参观锦汉家居用品及礼品展线上展',
  'setPassWord': '您还未设置密码,现在去设置密码,是否继续?',
  'Reset password successfully': '重置密码成功。',
  'tips':'提示',
  'ok':'确定',
  'cancel':'取消',
  'infoCn': '您目前使用的语言与创建账号时选用的语言不一致，请切换为中文语言来查看信息',
  'infoEn': '您目前使用的语言与创建账号时选用的语言不一致，请切换为英文语言来查看信息',
  'aboutus': '关于我们',
  'comingSoon2': '您的登记信息还没完整，请前往补充填写',
  'auditTip':'您提交的信息正在审核中，请耐心等待，如有问题，请联系info@jinhanfair.com',
  'auditTip1':'抱歉，您提交的信息未通过审核，请重新提交符合要求的证件资料，如有问题，请联系info@jinhanfair.com',
  'resiInfo': '马上预登记',
  'Please enter your code': '请输入您的验证码',
  'change': '换一批',
  'productError': '保存失败：产品类别最多选择三个。',
  'exportCustomer': '导出意向客户',
  'liveName':'请输入直播名称',
  "liveKeyWorld":"关键字搜索",
  'liveStartTime':"请选择开播时间",
  'liveEndTime':"请选择结束时间",
  'liveSponsorName':'请输入展商名称',
  'messageMail': '通知',
  'Message management': '消息列表',
  'mail': {
    'INVITE': '邀约通知',
    'CHECKRESULT': '审核通知',
    'SPONSOR': '主办通知',
    'INTENTIONORDER': '意向订单通知'
  },
  'goBack': '返回上一步',
  'smsCodeLogin': '切换为验证码登录',
  'passwordLogin': '切换为密码登录',
  'registerTips': '请按住滑块,拖动到最右边,进行验证',
  'registerSuccessTips': '验证成功',
  'slideCode':'请滑动验证码',
  'Next': '继续',
  'emailConfirmation': '邮件确认',
  'emailTitle': '请在邮箱中确认您的登录信息',
  'emailContent1': '感谢您创建预登记账户，我们已给您发送了一封确认邮件，请登录您的邮箱查收并点击邮件中的',
  'emailContent2': '确认链接',
  'emailContent3': '，以完成您的预登记注册。',
  'emailContent4': '如您在收件箱中未收到此邮件，可能已被系统拦截，请在垃圾箱中查找。Gmail用户请到广告邮件中查找。',
  // 'emailContent5': '垃圾邮箱',
  // 'emailContent6': '中找回',
  'resendMessage': '重新发送邮件',
  'Service Email': '客服邮箱',
  'infoExistence': '用户已存在',
  'codeRrror': '验证码错误',
  'Create Account': '创建账号',
  'Confirm Email': '邮箱确认',
  'Set Password': '设置密码',
  'Fill in info': '填写信息',
  'Questionnaire': '问卷调查',
  'Completed': '完成注册',
  'Completed Registration': '完成注册',
  'registerCompletedTips': '注册成功',
  'registerSuccessContent': '您已成功注册锦汉家居礼品展，欢迎使用锦汉家居礼品展线上展的各种商贸功能，祝您观展愉快！如有任何问题，欢迎发邮件至info@jinhanfair.com或致电+86(20)89899633',
  'registerCompletedTips1': '审核中',
  'registerSuccessContent1': '感谢您注册锦汉家居礼品展，您提交的信息正在审核中，请耐心等待，如有问题，请联系info@jinhanfair.com。',
  'registerCompletedTips2': '审核不通过',
  'registerSuccessContent2': '我们很抱歉通知您，您提交的锦汉家居礼品展注册申请未能通过审核，原因是：证件资料不符合要求。请重新提交符合要求的证件资料，我们将为您再次审核。如有问题，请联系info@jinhanfair.com.',
  'goHome': '进入首页',
  'Messag List': '消息列表',
  'baseInfo': '基本信息',
  'Head Image1': '请上传您的证件照，',
  'Head Image2': '该照片将同时用于展会进场证件',
  'workPassTips': '请上传您的个人工作证照片',
  'registrationTips': '请上传您的《外国地区常驻代表机构登记证》照片',
  'Please select the visible range': '请选择可见范围',
  'Please select the visible range2': '请选择产品标签或可见范围',
  'Please select the exhibits to be modified': '请选择要修改的展品',
  'Batch editing': '批量编辑',
  'Batch deletion': '批量删除',
  'Select the current page': '选择当前页',
  'No data on the current page': '当前页面没有数据',
  'a olute or self-relative': '格式不正确',
  'exhformTisp': '注意：',
  'exhformTisp1': '有点击率才能带来转化率',
  'exhformTisp2': '良好的产品展示，能更好的体现卖点，吸引买家点击',
  'exhformTisp3': '核心四图，决定客户是否点击和继续浏览',
  'exhformTisp4': '1.明亮美观,吸引点击',
  'exhformTisp5': '2.展示多颜色、多款式',
  'exhformTisp6': '3.展示优点或者细节',
  'exhformTisp7': '4.说明优惠活动，促进下单',
  'exhformTisp9': '1.此处上传的是单个产品的图片，可上传该产品不同角度，不同款式的图片',
  'exhformTisp10': '2.尺寸不低于750*750像素，支持png、jpg格式，不超过2Mb，您最多可上传十张产品图',
  'exhformTisp11': '提高点击率 主视频先行',
  'exhformTisp12': '相比平面图片，买家更愿意看到生动的视频',
  'exhformTisp13': '产品视频会优先于产品图片被买家看到',
  'exhformTisp14': '视频封面在视频未播放时出现在视频位置',
  'exhformTisp15': '1. 视频封面支持png、jpg格式，不超过1Mb，您可以上传一张封面图',
  'exhformTisp16': '2.视频支持mp4格式，不超过100Mb，您可以上传一个视频',
  'exhformTisp17': '3.视频封面和视频为正方形时，才可获得最佳展示效果',
  'exhformTisp18': '准确选择产品标签，帮助您更精准匹配优质买家',
  'exhformTisp19': '提高转化率 详情要精彩',
  'exhformTisp20': '上传展品详情，突出产品定位和卖点，在众多产品中脱颖而出',
  'exhformTisp21': '用精美的图文讲述故事、介绍产品、描述场景',
  'exhformTisp22': '1.此处上传展品详情图文，为获得最佳显示效果与加载速度，需将图片分段上传',
  'exhformTisp23': '2.建议的每段图片尺寸为1200*600,支持png、jpg格式，不超过1Mb',

  'Cancel the full selection': '取消全选',
  'releaseTips':'您可通过商脉圈发布供应信息，与您选择匹配的目标客户，将通过他/她的商脉圈看到您的发布，为您带来商机。',     
  'hot exhibits': '热门展商',
  'productRangeTip': '全部可见的产品数量最多上传10个，其他范围数量不限',
  'productRangeTip2': ['共', '张,还可以上传', '张'],
  'contactPerson': '您的账号不存在，请联系贵公司管理员创建',
  'noPassword': '此账号未设置密码，请先设置密码，3s自动跳转到设置密码页面',
  'invitationCode': '邀请码',
  'invitationCodeTips1': '1.展商可以将邀请码发送给目标观众',
  'invitationCodeTips2': '2.观众通过邀请码可以查看仅客户池可见的直播与展品',
  'invitationCodeTips3': '3.通过邀请码邀请的观众将会直接加入您的客户池',
  'clickCopy': '点击复制',

  'actorLoginTips': '注意:如账号已创建，首次登录请点"忘记密码"先进行密码设置',
  'note2': '请注意：',
  'noteText': ['最多只能选择 ', ' 个'],
  'Please upload a cover image of the video while uploading the video. Otherwise the front-end display will be blank.': '上传视频的同时请上传一张视频的封面图。否则前端显示会是空白',
  'Please upload Video.': '请上传视频',
  'Watch the live stream.': '观看直播',
  'You need to invite exhibitors, or use the invitation code to watch the live broadcast': '需要邀约展商，或使用邀请码观看直播',
  'To watch the live broadcast, please invite the exhibitor immediately or enter the invitation code to watch.': '观看直播需邀约展商，请',
  'Invite now': '立即邀约',
  'Or, enter the invitation code and watch': '或，输入邀请码后查看',
  'Please enter the invitation code': '请输入邀请码',
  'Contact exhibitors via IM to get the invitation code': '通过IM联系展商获取邀请码', 
  'determine': '确 定',
  'actorDetailRegister': '立即注册可查看更多产品',
  'actorDetailInite': '邀约展商可查看更多产品',
  'actorDetailInite2': '或，输入邀请码后直接查看',
  
  'Invitation code error': '邀请码错误',
  'Password error': '密码错误',
  'Private live broadcasting': '私密直播',
  'inviteTips': '成功邀约展商，可以加入到展商客户池，查看更多经展商授权的展品和直播。',
  'For details, please invite exhibitors': '查看详情需邀约展商，请',
  'Unregistered users can only see limited products. Please register to view more.': '未注册用户仅看到展商全部公开的产品，要查看更多产品，需先完成注册。',
  'inviteTips2': '邀约展商，加入展商客户池，可以在展商展厅里查看到更多产品。',
  'onLine': '本机网络已连接，请刷新您的页面',
  'offLine': '本机网络掉线, 请检查您的网络',
  'withoutPermission': '当前账号未开通该功能，请联系主办方开通权益',
  'Modify file name': '修改文件名',

  'This will permanently delete the file. Continue?': '此操作将永久删除该文件, 是否继续?',
  'Delete completed': '删除成功',
  'Please enter a file name': '请输入文件名',
  'filename is incorrect': '文件名不正确',
  'Revise Success': '修改成功',
  'Upload information': '上传资料',
  'Exhibitor information': '展商资料',
  '编辑公司资料': '编辑公司资料',
  '编辑展品资料': '编辑展品资料',
  '如何管理公司资料': '如何管理公司资料',
  '如何管理展品': '如何管理展品',
  '本平台仅对正式参展商开放服务': '本平台仅对正式参展商开放服务',
  '请使用报名参展手机号登录系统': '请使用报名参展手机号登录系统',
  '面料展展商平台使用指南': '面料展展商平台使用指南'
  


}